import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Button, Card, Spinner } from 'flowbite-react';
import { HiCheckCircle, HiShieldCheck } from 'react-icons/hi';

export default function Home() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <Spinner size="xl" className="mx-auto" />
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <img 
              src="/logo.svg" 
              alt="Domus Secura" 
              className="h-20 w-auto"
            />
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Domus Secura
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Sistema de seguridad domótica multi-tenant
          </p>

          {user ? (
            <Card className="max-w-md mx-auto">
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <HiCheckCircle className="w-8 h-8 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">¡Bienvenido!</h2>
                <p className="text-gray-600 mb-6">{user.email}</p>
                <Button as={Link} to="/dashboard" className="w-full bg-blue-600 hover:bg-blue-700">
                  Ir al Dashboard
                </Button>
              </div>
            </Card>
          ) : (
            <Card className="max-w-md mx-auto">
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <HiShieldCheck className="w-8 h-8 text-blue-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Inicia sesión para continuar</h2>
                <div className="space-y-3">
                  <Button as={Link} to="/login" className="w-full bg-blue-600 hover:bg-blue-700">
                    Iniciar Sesión
                  </Button>
                  <Button as={Link} to="/register" color="light" className="w-full">
                    Registrarse
                  </Button>
                </div>
              </div>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
}
